import { useQuery } from '@tanstack/react-query'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { ProjectService } from 'src/services/project.service'
import { TVariable } from 'src/types/variable'

export function useProjectVariables() {
  const { project } = useCurrentProject()

  return useQuery<TVariable[]>({
    queryKey: ['variables', project?.id],
    queryFn: () => ProjectService.getVariables(project!.id),
    enabled: !!project?.id,
  })
}
